import { ENTRYPOINT } from '../../../config/entrypoint';
import { API_ROUTES } from '../../../constants/api_routes';
import { getData } from '../../../http/request';
import { isValid } from 'date-fns';
import { formatDate } from '../../../utils/helper_functions';

export const GRAPH_ANALYTICS_ACTION_TYPES = {
    CHANGE_FILTERS: 'GRAPH_ANALYTICS_CHANGE_FILTERS',
    GET_CUSTOMERS_DAILY_COUNT: 'GET_CUSTOMERS_DAILY_COUNT',
    GET_CUSTOMERS_MONTLY_COUNT_BY_WORKERS: 'GET_CUSTOMERS_MONTLY_COUNT_BY_WORKERS',
    GET_APPOINTMENTS_MONTLY_COUNT_BY_WORKERS: 'GET_APPOINTMENTS_MONTLY_COUNT_BY_WORKERS',
    GET_APPOINTMENTS_COUNT_BY_CUSTOMERS: 'GET_APPOINTMENTS_COUNT_BY_CUSTOMERS'
};

const CUSTOMERS_DAILY_COUNT_URL = `${ENTRYPOINT}${API_ROUTES.CUSTOMERS_DAILY_COUNT}`;
const APPOINTMENTS_MONTLY_COUNT_BY_WORKERS_URL = `${ENTRYPOINT}${API_ROUTES.APPOINTMENTS_MONTLY_COUNT_BY_WORKERS}`;
const APPOINTMENTS_COUNT_BY_CUSTOMERS_URL = `${ENTRYPOINT}${API_ROUTES.APPOINTMENTS_COUNT_BY_CUSTOMERS}`;

const setZeroTime = (date) => {
    return date ? new Date(date.setHours(0, 0, 0, 0)) : null;
}

const getFilterParams = (filters = {}) => {
    const { startDate, endDate, worker, customer, article, subArea } = filters;
    let filterParams = [];
    if (startDate && isValid(startDate)) {
        const date = formatDate(setZeroTime(startDate));
        filterParams.push(`date[after]=${date}`);
    }
    if (endDate && isValid(endDate)) {
        const date = formatDate(setZeroTime(endDate));
        filterParams.push(`date[before]=${date}`);
    }
    if (worker && worker?.uuid) {
        filterParams.push(`worker=${worker.uuid}`);
    }
    if (customer && customer?.uuid) {
        filterParams.push(`customer=${customer.uuid}`);
    }
    if (article && article?.uuid) {
        filterParams.push(`article=${article.uuid}`);
    }
    if (subArea && subArea?.uuid) {
        filterParams.push(`subArea=${subArea.uuid}`);
    }

    return filterParams.join('&');
}

export const changeFilters = (filters) =>
    async (dispatch) => {
        dispatch({ type: GRAPH_ANALYTICS_ACTION_TYPES.CHANGE_FILTERS, payload: filters });
    }

export const getCustomersDailyCount = (filters) =>
    async (dispatch) => {
        const params = getFilterParams(filters);
        const response = await getData(`${CUSTOMERS_DAILY_COUNT_URL}?${params}`);
        dispatch({ type: GRAPH_ANALYTICS_ACTION_TYPES.GET_CUSTOMERS_DAILY_COUNT, payload: response?.customerDailyCount });
        dispatch({ type: GRAPH_ANALYTICS_ACTION_TYPES.GET_CUSTOMERS_MONTLY_COUNT_BY_WORKERS, payload: response?.customerMonthlyCountByWorkers });
    }

export const getAppointmentsMontlyCountByWorkers = (filters) =>
    async (dispatch) => {
        const params = getFilterParams(filters);
        const response = await getData(`${APPOINTMENTS_MONTLY_COUNT_BY_WORKERS_URL}?${params}`);
        dispatch({ type: GRAPH_ANALYTICS_ACTION_TYPES.GET_APPOINTMENTS_MONTLY_COUNT_BY_WORKERS, payload: response });
    }

export const getAppointmentsCountByCustomers = (filters) =>
    async (dispatch) => {
        const params = getFilterParams(filters);
        const response = await getData(`${APPOINTMENTS_COUNT_BY_CUSTOMERS_URL}?${params}`);
        dispatch({ type: GRAPH_ANALYTICS_ACTION_TYPES.GET_APPOINTMENTS_COUNT_BY_CUSTOMERS, payload: response });
    }